import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=4f046259&"
import script from "./lunbo.vue?vue&type=script&lang=js&"
export * from "./lunbo.vue?vue&type=script&lang=js&"
import style0 from "./lunbo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports